import { FC } from "react";
import { TextField, Stack, InputAdornment } from "@mui/material";
import { Search, Clear } from "@mui/icons-material";
import { useCollectionsContext } from "../hooks/useCollectionsContext";
import { CollectionTypeSelect } from "../../../../components/CollectionTypeSelect/CollectionTypeSelect";

export const CollectionsFilters: FC = () => {
  const { searchQuery, setSearchQuery, typeFilter, setTypeFilter } =
    useCollectionsContext();
  return (
    <Stack direction="row" spacing={3} alignItems="end">
      <TextField
        placeholder="Search"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        variant="standard"
        size="small"
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <Search fontSize="small" />
              </InputAdornment>
            ),
            endAdornment: searchQuery && (
              <InputAdornment position="end">
                <Clear
                  fontSize="small"
                  onClick={() => setSearchQuery("")}
                  sx={{ cursor: "pointer" }}
                />
              </InputAdornment>
            ),
          },
        }}
        sx={{ width: 300 }}
      />

      <CollectionTypeSelect
        type={typeFilter}
        setType={setTypeFilter}
        enableAllOption
      />
    </Stack>
  );
};
